<template>
  <div class="storageInventoryDaily">
    <h1>库存成本表</h1>
    <el-form :inline="true">
      <el-form-item label="日期">
        <el-date-picker v-model="searchParam.date" style="width: 220px;" />
      </el-form-item>
      <el-form-item label="仓储">
        <el-select v-model="searchParam.storage" filterable style="width: 120px;" clearable>
          <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-row :gutter="20">
      <el-col :span="10">
        <el-table :data="data.inList" border style="height: calc(100vh - 310px);" show-summary :summary-method="summaryIn">
          <el-table-column prop="storage" label="仓储" width="120" show-overflow-tooltip />
          <el-table-column prop="product" label="煤矿品名" width="120" show-overflow-tooltip />
          <el-table-column prop="inQuantity" label="入库数量" show-overflow-tooltip align="right">
            <template #default="scope">
              {{ math.formatNumber(scope.row.inQuantity) }}
            </template>
          </el-table-column>
          <el-table-column label="单价" show-overflow-tooltip align="right">
            <template #default="scope">
              <el-text>{{ math.formatNumber(math.halfUp(scope.row.productAmount / scope.row.inQuantity, 2)) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column label="上游运费单价" width="120" show-overflow-tooltip align="right">
            <template #default="scope">
              <el-text>{{ math.formatNumber(math.halfUp(scope.row.transportAmount / scope.row.inQuantity, 2)) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column prop="afterQuantity" label="累计入库" show-overflow-tooltip align="right">
            <template #default="scope">
              {{ math.formatNumber(scope.row.afterQuantity) }}
            </template>
          </el-table-column>
        </el-table>
        <div style="height: 10px;" />
        <el-pagination v-model:current-page="searchParam.inPageNum" v-model:page-size="searchParam.inPageSize" :page-sizes="[300, 500, 1000, 2000]" background layout="total, sizes, prev, pager, next, jumper" :total="data.inTotal"
          @change="commitFindInList()" />
      </el-col>
      <el-col :span="14">
        <el-table :data="data.outList" border style="height: calc(100vh - 310px);" show-summary :summary-method="summaryOut">
          <el-table-column prop="storage" label="仓储" width="120" show-overflow-tooltip />
          <el-table-column prop="product" label="煤矿品名" width="120" show-overflow-tooltip />
          <el-table-column prop="outQuantity" label="出库数量" show-overflow-tooltip align="right">
            <template #default="scope">
              {{ math.formatNumber(scope.row.outQuantity) }}
            </template>
          </el-table-column>
          <el-table-column label="推算单价" show-overflow-tooltip align="right">
            <template #default="scope">
              <el-text>{{ math.formatNumber(math.halfUp(scope.row.productAmount / scope.row.outQuantity, 2)) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column label="推算运价" width="120" show-overflow-tooltip align="right">
            <template #default="scope">
              <el-text>{{ math.formatNumber(math.halfUp(scope.row.transportAmount / scope.row.outQuantity, 2)) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column label="实时单价" show-overflow-tooltip align="right">
            <template #default="scope">
              <el-text>{{ math.formatNumber(math.halfUp(scope.row.inventoryProductAmount / scope.row.outQuantity, 2)) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column label="实时运价" width="120" show-overflow-tooltip align="right">
            <template #default="scope">
              <el-text>{{ math.formatNumber(math.halfUp(scope.row.inventoryTransportAmount / scope.row.outQuantity, 2)) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column prop="afterQuantity" label="累计出库" show-overflow-tooltip align="right">
            <template #default="scope">
              {{ math.formatNumber(scope.row.afterQuantity) }}
            </template>
          </el-table-column>
        </el-table>
        <div style="height: 10px;" />
        <el-pagination v-model:current-page="searchParam.outPageNum" v-model:page-size="searchParam.outPageSize" :page-sizes="[300, 500, 1000, 2000]" background layout="total, sizes, prev, pager, next, jumper" :total="data.outTotal"
          @change="commitFindOutList()" />
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()

const data = reactive({
  inTotal: 0,
  inList: [],
  inData: {},
  outTotal: 0,
  outList: [],
  outData: {},
})

const show = reactive({
  storageList: [],
})
api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})

const now = new Date()
const yesterday = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000)

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.inPageNum = 1
  searchParam.inpageSize = 300
  searchParam.outPageNum = 1
  searchParam.outpageSize = 300
  searchParam.date = yesterday
  searchParam.storage = null
}
resetSearchParam()

const commitFindInList = () => {
  const params = {}
  console.log(searchParam)
  params.pageNum = searchParam.inPageNum
  params.pageSize = searchParam.inPageSize
  params.storage = searchParam.storage
  params.receiveDate = util.parseTime(searchParam.date, '{y}-{m}-{d}')
  api.get('/backend/inventory/inPage', { params: params }).then(res => {
    data.inList = res.list
    data.inTotal = res.total
    data.inData = res.data
  })
}

const commitFindOutList = () => {
  const params = {}
  params.pageNum = searchParam.outPageNum
  params.pageSize = searchParam.outPageSize
  params.storage = searchParam.storage
  params.sendDate = util.parseTime(searchParam.date, '{y}-{m}-{d}')
  api.get('/backend/inventory/outPage', { params: params }).then(res => {
    data.outList = res.list
    data.outTotal = res.total
    data.outData = res.data
  })
}

const commitFindList = () => {
  data.inList = []
  data.inTotal = 0
  data.outList = []
  data.outTotal = 0
  commitFindInList()
  commitFindOutList()
}

const summaryIn = () => {
  return ['', '', math.formatNumber(data.inData.inQuantity), math.formatNumber(data.inData.averageProductPrice), math.formatNumber(data.inData.averageTransportPrice), '']
}

const summaryOut = () => {
  return ['', '', math.formatNumber(data.outData.outQuantity), math.formatNumber(data.outData.averageProductPrice), math.formatNumber(data.outData.averageTransportPrice), '']
}
</script>

<style lang="less"></style>